// extracted by mini-css-extract-plugin
export default {"containerCal":"calculdora_containerCal__LzNHW","fila":"calculdora_fila__P-54c","pantalla":"calculdora_pantalla__7JrV+","clear":"calculdora_clear__cmItH"};